<!-- toolbar -->
<div class="flex items-center justify-between">
  <p hlmSmall class="text-sm text-muted-foreground">Protocols Management</p>
</div>

<section hlmCard>
  <div hlmCardHeader class="pb-4">
    <div class="flex items-center justify-between">
      <h2 hlmCardTitle class="text-xl">Protocols</h2>

      <button hlmBtn class="flex h-8 gap-2" (click)="openCreateDialog()">
        <ng-icon hlm name="circle-plus" size="sm" />
        Create Protocol
      </button>
    </div>

    <p hlmCardDescription class="mt-2">Manage protocols, steps, and instruction files</p>
  </div>

  <div hlmCardContent>
    <!-- table component -->
    <app-protocols-table
      [protocolList]="protocolList()"
      (deleteEvent)="openDeleteDialog($event)"
      (viewEvent)="viewProtocol($event)"
    />
  </div>
</section>

<!-- Delete Protocol Dialog -->
<brn-alert-dialog #alertDialog>
  <brn-alert-dialog-overlay hlm></brn-alert-dialog-overlay>
  <hlm-alert-dialog-content *brnAlertDialogContent="let ctx">
    <hlm-alert-dialog-header>
      <h3 hlmAlertDialogTitle>Delete Protocol</h3>
      <p hlmAlertDialogDescription>
        Are you sure you want to delete this protocol? This action cannot be undone.
      </p>
    </hlm-alert-dialog-header>
    <hlm-alert-dialog-footer>
      <button hlmAlertDialogCancel (click)="ctx.close()">Cancel</button>
      <button hlmAlertDialogAction variant="destructive" (click)="deleteProtocol(ctx)">
        Delete
      </button>
    </hlm-alert-dialog-footer>
  </hlm-alert-dialog-content>
</brn-alert-dialog>

<!-- Create Protocol Dialog -->
<brn-dialog #createDialog>
  <brn-dialog-overlay hlm />
  <hlm-dialog-content *brnDialogContent="let ctx" class="max-w-fit">
    <hlm-dialog-header>
      <h3 hlmDialogTitle>Create New Protocol</h3>
      <p hlmDialogDescription>Fill in the details to create a new protocol.</p>
    </hlm-dialog-header>

    <div class="flex flex-col gap-4 py-4">
      <div class="flex flex-col gap-2">
        <label hlmLabel for="name">Name</label>
        <input hlmInput id="name" [(ngModel)]="newProtocol.name" placeholder="Protocol name" />
      </div>

      <div class="flex flex-col gap-2">
        <label hlmLabel for="description">Description</label>
        <input
          hlmInput
          id="description"
          [(ngModel)]="newProtocol.description"
          placeholder="Protocol description"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label hlmLabel for="global_prompt">Global Prompt (Optional)</label>
        <textarea
          hlmInput
          id="global_prompt"
          class="min-h-[250px] w-[500px]"
          [(ngModel)]="newProtocol.global_prompt"
          placeholder="Global prompt for the protocol"
          rows="20"
        ></textarea>
      </div>
    </div>

    <hlm-dialog-footer>
      <button hlmBtn variant="outline" (click)="ctx.close()">Cancel</button>
      <button hlmBtn (click)="createProtocolAndCloseDialog(ctx)">Create</button>
    </hlm-dialog-footer>
  </hlm-dialog-content>
</brn-dialog>
